import { z } from "zod";
import i18n from "~/i18n";

// Keep the length limit in sync with governanceUnitNameSchema in
// api/src/v2/features/governance-units/governance-unit.schema.ts.
const GOVERNANCE_UNIT_NAME_MAX_LENGTH = 255;

export const governanceUnitNameSchema = z
  .string()
  .trim()
  .min(
    1,
    i18n.t(($) => $.validations.required),
  )
  .max(
    GOVERNANCE_UNIT_NAME_MAX_LENGTH,
    i18n.t(($) => $.validations.maxLength, {
      max: GOVERNANCE_UNIT_NAME_MAX_LENGTH,
    }),
  );
